export default __webpack_public_path__ + "static/media/coinbaseWallet.177a7432.svg";